import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CoachPageLayout from '../CoachPageLayout/CoachPageLayout';

function NotFound() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const theme = useTheme();

  return (
    <CoachPageLayout hideBreadCrumb>
      <Grid
        container
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        gap="36px"
        bgcolor="#fff"
        boxShadow={theme.borderStyles.cardBorders}
      >
        <Grid item>
          <img src="/assets/icons/not-found.svg" alt="not-found" />
        </Grid>
        <Grid
          item
          xs={language.split('-')[0] === 'pt' ? 5 : 4}
          textAlign="center"
          gap={3}
          display="flex"
          flexDirection="column"
        >
          <Grid>
            <Typography variant="title2Bold" color="primary">
              {t('notFound.404')}
            </Typography>
          </Grid>
          <Grid gap="12px" display="flex" flexDirection="column">
            <Typography variant="bodyRegular" color="primary">
              {t('notFound.whatYouCanDo')}:
            </Typography>
            <Grid display="flex" flexDirection="column" alignItems="center">
              <Grid display="flex" flexDirection="row">
                <Typography variant="bodyRegular" color="primary" fontWeight={700}>
                  {t('notFound.checkUrl')}:
                </Typography>
                <Typography variant="bodyRegular" color="primary">
                  &nbsp;{t('notFound.ensureEnteredCorrectly')}
                </Typography>
              </Grid>
            </Grid>
            <Typography variant="bodyRegular" color="primary">
              {t('notFound.thankYou')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </CoachPageLayout>
  );
}

export default NotFound;
